<template>
  <div id="flash-container">
    <transition-group name="fade" v-for="(f, index) in allFlashes" :key="index">
      <div :id='index' :key="index" :class="f.type + ' ls-md-margin-bottom ls-dismissable'">
        <span data-ls-module="dismiss" class="ls-dismiss" @click.prevent="removeFlash(index)">&times;</span>
        <strong v-if="!(f.hideWarning === true)">{{ flashPrefix(f.type) }}</strong>
        <p v-html="f.message"></p>
        <div v-for="error in f.errors">
          <p v-html="error"></p>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    methods: {
      ...mapMutations(['clearFlash', 'clearPaginationFlash', 'setKeepFlash']),
      flashPrefix (type) {
        return this.$t('application.alert.' + type.replace(/ls-alert-/g, ''))
      },
      removeFlash (index) {
        let element = document.getElementById(index)
        element.parentNode.removeChild(element)
      }
    },
    computed: {
      ...mapGetters(['flashes', 'paginationFlashes', 'keepFlash']),
      allFlashes () {
        let flashes = this.flashes.concat(this.paginationFlashes)

        flashes = flashes.filter(function (flash) {
          return !this[JSON.stringify(flash)] && (this[JSON.stringify(flash)] = true)
        }, Object.create(null))
        return flashes
      }
    },
    beforeDestroy () {
      if (!this.keepFlash) this.clearFlash()
      this.clearPaginationFlash()
    },
    mounted () {
      this.setKeepFlash(false)
    }
  }
</script>

<style lang="scss">
  .errors {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// FlashMessage.vue?22f51ff7